@if (hasPublishedItems()) {
<rds-divider class="divider"></rds-divider>
<div class="integrations">
  <h1 class="ui-heading-1-bold integrations-title">{{ knowledgeSection() }}</h1>

  <div class="integrations-content">
    <div [innerHTML]="integrationLongDescription() | safeHtml"></div>
    @for(i of integrations(); track $index) {
      @if(i.published === true) {
      <div class="integration-item">
        <h3 class="ui-heading-3">{{ i.title }}</h3>
        <div [innerHTML]="i.description | safeHtml"></div>

        <a rds-link standalone href="{{ i.url }}" target="_blank">
          {{ i.title }}
          <rds-icon namespace="filled" icon="arrow_right" />
        </a>
      </div>
      }
    }
  </div>
</div>
}
